import { render, staticRenderFns } from "./PMN-Client.vue?vue&type=template&id=f804202a&scoped=true&"
import script from "./PMN-Client.vue?vue&type=script&lang=ts&"
export * from "./PMN-Client.vue?vue&type=script&lang=ts&"
import style0 from "./PMN-Client.vue?vue&type=style&index=0&id=f804202a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f804202a",
  null
  
)

export default component.exports